import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Flex from 'components/Flex';
import TooltipButton from 'components/TooltipButton';
import { CommentSizesContext } from '../Context';
function CommentFormTitleBar(_ref) {
  var title = _ref.title,
    _ref$isNested = _ref.isNested,
    isNested = _ref$isNested === void 0 ? false : _ref$isNested,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var size = useContext(CommentSizesContext);
  return /*#__PURE__*/React.createElement(Flex, {
    mb: "xxxs",
    align: "center",
    ml: isNested ? 76 : 42
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    bold: true,
    mr: "xs",
    fontSize: size === 'DEFAULT' ? 'xs' : ['xs', 'm'],
    breakpoints: "m",
    overflow: "ellipsis"
  }, title), /*#__PURE__*/React.createElement(TooltipButton, {
    icon: "x",
    size: "small",
    variant: "transparent",
    title: t('actions_cancel'),
    onClick: onClose
  }));
}
export default CommentFormTitleBar;